<template>
    <form class="card">
        <h3>Букинг</h3>
        <Booking v-if="status == ''" :data.sync="data"></Booking>
    </form>
</template>

<script>
    import Booking from '@/components/forms/Booking.vue'
    export default {
        props: ['status', 'data'],
        components: {
            Booking
        },
        created () {
            this.$emit('getData')
        }
    }
</script>